export const API_URL = process.env.PDFX_URL;
